module.exports = __webpack_public_path__ + "static/media/pexels-junior-teixeira-2047905.7e6b0b94.jpg";